import { ColumnDef } from "@tanstack/react-table";

import { useForm, useWatch } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import APIS from "../../constant/Endpoint";
import StockLedgerTable from "../Reusable/StockLedgerTable";
import Filter from "./Filter";
import { useDownload } from "@careinfo/layout";
import { tw } from "@careinfo/tailwind";
import moment from "moment";
import Button from "../Reusable/Button";

const StockLedger = () => {
  const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
  const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
  const [searchParams, setSearchParams] = useSearchParams();
  const { download } = useDownload();
  const {
    control,
    register,
    getValues,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm<any>({
    defaultValues: {
      account: searchParams.get("account") || "",
      user: searchParams.get("user") || "",
      created__range: `${startOfMonth},${endOfMonth}`,
      created: searchParams.get("created") || "",
    },
  });

  const formValues = useWatch({ control });
  const columns: ColumnDef<any, any>[] = [
    {
      accessorKey: "created",
      header: "Date",
      cell: ({ getValue }: any) => {
        return (
          <p>
            {getValue() ? moment(getValue()).format("YY-MM-DD HH:mm:ss") : ""}
          </p>
        );
      },
    },
    {
      accessorKey: "created_miti",
      header: "Miti",
      cell: ({ getValue }: any) => {
        return (
          <p>
            {getValue() ? moment(getValue()).format("YY-MM-DD HH:mm:ss") : ""}
          </p>
        );
      },
    },

    {
      accessorKey: "bill.bill_no",
      header: "Bill No.",
    },
    {
      accessorKey: "bill.party",
      header: "Particulars",
    },
    {
      accessorKey: "quantity",
      header: "Received",
      cell: ({ row, getValue }: any) => {
        return <p> {row?.original?.is_sales ? "" : getValue()}</p>;
      },
    },
    {
      accessorKey: "quantity",
      header: "Delivered",
      cell: ({ row, getValue }: any) => {
        return <p> {row?.original?.is_sales ? getValue() : ""}</p>;
      },
    },
  ];
  const handleDownloadExcel = async () => {
    try {
      const cleanedParams = Object.fromEntries(
        Object.entries(formValues)
          .filter(
            ([, value]) => value !== null && value !== undefined && value !== ""
          )
          .map(([key, value]) => [key, String(value)])
      );

      const queryString = new URLSearchParams(cleanedParams).toString();

      await download(
        `${APIS.PRODUCT}normal-ledger-excel-download/?${queryString}`,
        `stock-ledger-${moment().format("MMMM-Do-YYYY-h-mm-ss")}.xlsx`
      );
    } catch (e) {
      console.error(e);
    }
  };
  return (
    <>
      <Filter
        register={register}
        errors={errors}
        setValue={setValue}
        getValues={getValues}
        clearErrors={clearErrors}
      />
      <div className={tw`flex justify-end mb-2`}>
        <div className={tw`w-24`}>
          <Button label="Download" onClick={() => handleDownloadExcel()} />
        </div>
      </div>
      <StockLedgerTable
        customSearch={true}
        columns={columns}
        queryKey="stock-ledger"
        url={`${APIS.PRODUCT}stock-ledger/`}
        params={formValues}
      />
    </>
  );
};

export default StockLedger;

